import ExtractOrderList from "../ExtractOrderList";

export default function CenterPage({ txList }) {
  return (
    <div className="rechargeorderlist-1">
      <ExtractOrderList />
    </div>
  );
}
